<template>
  <div class="bg-white shadow-md rounded-lg overflow-hidden w-full">
    <div v-if="loading" class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
      <div class="spinner"></div>
    </div>
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-primary text-white">
        <tr>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
          >
            Title
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
          >
            Department
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
            style="max-width: 100px"
          >
            Target Module
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
            style="max-width: 50px"
          >
            Status
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
            style="max-width: 50px"
          >
            Sub Status
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
          >
            Start Date
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
          >
            End Date
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
            style="min-width: 200px"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="survey in surveys" :key="survey.id">
          <td class="whitespace-nowrap"> <a @click="downloadList(survey)" style="text-decoration: underline;cursor: pointer;max-width: 100px;">{{ survey.title }}</a></td>
          <td class="whitespace-nowrap" style="max-width: 100px">
            {{ survey.department }}
          </td>
          <td class="whitespace-nowrap" style="max-width: 100px">
            <span v-if="survey.targetModule && survey.targetModule.length > 0">
              {{
                survey.targetModule
                  .map((moduleId) => getModuleName(moduleId)).length > 4 ?
                    survey.targetModule
                    .map((moduleId) => getModuleName(moduleId))
                    .slice(0, 4)
                    .join(", ") + "..."
                  :
                  survey.targetModule
                  .map((moduleId) => getModuleName(moduleId)).join(", ")
              }}
            </span>
            <span v-else>N/A</span>
          </td>
          <td class="whitespace-nowrap"
          style="min-width:90px;max-width: 90px"
          >
            <span :class="getStatusClass(survey.status)">{{
              survey.status
            }}</span>
          </td>
          <td class="whitespace-nowrap"
          style="min-width:100px;max-width: 100px"
          >
            <span
              v-if="survey.status === 'Published'"
              :class="getPublishedStatusClass(survey.publishedStatus)"
            >
              {{ survey.publishedStatus }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="whitespace-nowrap">
            {{ formatDate(survey.startDate) }}
          </td>
          <td class="whitespace-nowrap">
            {{ formatDate(survey.endDate) }}
          </td>
          <td class="whitespace-nowrap text-sm font-medium"
          style="max-width: 200px">
            <button
              @click="$emit('edit', survey)"
              class="text-indigo-600 hover:text-indigo-900 mr-2"
              v-if="canEdit(survey)"
            >
              Edit
            </button>
            <button
              @click="$emit('preview', survey)"
              class="text-blue-600 hover:text-blue-900 mr-2"
            >
              Preview
            </button>
            <button
              v-if="
                (survey.status === 'Draft' || survey.status == 'Revoked') &&
                canEdit(survey)
              "
              @click="$emit('publish', survey.id)"
              class="text-green-600 hover:text-green-900 mr-2"
            >
              Publish
            </button>
            <button
              v-if="survey.status === 'Published' && canEdit(survey)"
              @click="$emit('revoke', survey.id)"
              class="text-yellow-600 hover:text-yellow-900 mr-2"
            >
              Revoke
            </button>
            <button
              v-if="survey.type === 'University'"
              @click="$emit('detail', survey)"
              class="text-purple-600 hover:text-purple-900 mr-2"
            >
              Detail
            </button>
            <button
              @click="$emit('delete', survey.id)"
              class="text-red-600 hover:text-red-900"
              v-if="canEdit(survey)"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
    
<script>
import { mapState } from "vuex";
import { reportsApi } from "@/api/reports";
export default {
  name: "SurveyTable",
  props: {
    surveys: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      modules: (state) => state.modules,
      userRole: (state) => state.auth.userRole,
    }),
  },
  methods: {
    async downloadList(survey) {
      this.loading = true;
      let blob = await reportsApi.exportSurveyListReport(survey.id, survey.type);
      this.loading = false;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${survey.title}.xlsx`);
      link.setAttribute("download", `${survey.title}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    canEdit(survey) {
      console.log(this.userRole);
      if (this.userRole === "admin") return true;
      else if (survey.type == "University") return false;
      return true;
    },
    getStatusClass(status) {
      switch (status.toLowerCase()) {
        case "draft":
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800";
        case "published":
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800";
        case "revoked":
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800";
        default:
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800";
      }
    },
    getPublishedStatusClass(status) {
      switch (status.toLowerCase()) {
        case "pending":
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800";
        case "active":
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800";
        case "completed":
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800";
        default:
          return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800";
      }
    },
    formatDate(date) {
      if (!date) return "N/A";
      return new Date(date).toLocaleString('en-US', { hour12: false });
    },
    getModuleName(moduleId) {
      const module = this.modules.find((m) => m.id === moduleId);
      return module ? `${module.moduleCode}` : "Unknown Module";
    },
  },
};
</script>
    
<style scoped>
td {
  max-width: 100px;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1024px) {
  td {
    max-width: 50px;
    padding-left: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

td:hover {
  overflow: visible;
  white-space: normal;
  word-break: break-word;
  position: relative;
  z-index: 1;
}
</style>
    
    